interface ToolsFieldProps {
    heading: string;
    disabled: boolean;
    enabledTools: Set<string>;
    onToggle: (tool: string) => void;
    toolDefaults: Set<string>;
    onToggleDefault: (tool: string) => void;
}

export const ToolsField = ({ heading, disabled, enabledTools, onToggle, toolDefaults, onToggleDefault }: ToolsFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        <p className={`text-sm mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            Enable optional capabilities for your assistant.
        </p>
        <div className="flex gap-3">
            <div className="flex flex-col gap-2">
                <button
                    type="button"
                    onClick={() => onToggle('reasoning')}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md border text-sm font-medium transition ${enabledTools.has('reasoning')
                        ? 'border-jtc-blue bg-jtc-blue/10 text-jtc-blue'
                        : 'border-jtc-grey text-gray-500 hover:border-gray-400'
                        }`}
                >
                    <span className="material-symbols-outlined text-[18px] leading-none">psychology</span>
                    Thinking
                </button>
                {enabledTools.has('reasoning') && (
                    <label className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={toolDefaults.has('reasoning')}
                            onChange={() => onToggleDefault('reasoning')}
                            disabled={disabled}
                            className="accent-jtc-blue"
                        />
                        On by default
                    </label>
                )}
            </div>
            <div className="flex flex-col gap-2">
                <button
                    type="button"
                    onClick={() => onToggle('web_search')}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md border text-sm font-medium transition ${enabledTools.has('web_search')
                        ? 'border-jtc-blue bg-jtc-blue/10 text-jtc-blue'
                        : 'border-jtc-grey text-gray-500 hover:border-gray-400'
                        }`}
                >
                    <span className="material-symbols-outlined text-[18px] leading-none">captive_portal</span>
                    Web Search
                </button>
                {enabledTools.has('web_search') && (
                    <label className="flex items-center gap-2 text-sm text-gray-500 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={toolDefaults.has('web_search')}
                            onChange={() => onToggleDefault('web_search')}
                            disabled={disabled}
                            className="accent-jtc-blue"
                        />
                        On by default
                    </label>
                )}
            </div>
            <div className="flex flex-col gap-2">
                {/* No "On by default" checkbox: file generation has no per-question
                    toggle — enabling it here means it is always active. */}
                <button
                    type="button"
                    onClick={() => onToggle('file_generation')}
                    className={`flex items-center gap-2 px-4 py-2 rounded-md border text-sm font-medium transition ${enabledTools.has('file_generation')
                        ? 'border-jtc-blue bg-jtc-blue/10 text-jtc-blue'
                        : 'border-jtc-grey text-gray-500 hover:border-gray-400'
                        }`}
                >
                    <span className="material-symbols-outlined text-[18px] leading-none">note_add</span>
                    File Generation
                </button>
            </div>
        </div>
    </>
);
